import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import * as Yup from 'yup';
import { useFormik } from 'formik';

import { ReactComponent as Logo } from '../../assets/images/Radar_logo.svg';
import { FormControl } from '../../Components/ui/FormControl';
import classes from './loginPage.module.scss';
import { ReactComponent as Point } from '../../assets/images/point.svg';
import { useSecurity } from '../../hooks/entityHooks';
import { RestorePassword } from '../../Components/Dialogs/RestorePassword';
import { TwoFactorAuth } from '../../Components/Dialogs/twoFactorAuthDialog';

type FormikValues = {
  email: string;
  password: string;
};

type Props = {
  handleUserLogin(login: string): void;
};
export const LoginPage = ({ handleUserLogin }: Props) => {
  // const { login } = UseSecurity();
  const [open, setOpen] = useState(false);
  const [openAuth, setOpenAuth] = useState(false);

  const handleCloseAuth = () => {
    setOpenAuth(!openAuth);
  };

  const { login } = useSecurity();

  const useStyles = makeStyles({
    root: {
      backgroundColor: '#FF7221 !important',
      borderRadius: 0,
      width: '100%',
      color: 'white',
      // @ts-ignore
      textTransform: 'none !important',
      fontWeight: 550,
      '&:hover, &:focus': {
        background: '#C8524D',
      },
      '&:disabled': {
        background: '#1C1B1B80 !important',
        color: '#FFFFFF !important',
      },
      fontFamily: 'Inter, sans-serif',
      // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
      height: 50,
      padding: '0 30px',
    },
  });
  const {
    handleSubmit,
    handleBlur,
    values,
    errors,
    touched,
    setFieldValue,
    isValid,
  } = useFormik<FormikValues>({
    initialValues: {
      email: '',
      password: '',
    },
    onSubmit: async () => {
      const user = {
        email: values.email,
        password: values.password,
      };
      try {
        // await login(user);
        await login(user);
        handleCloseAuth();
        // const email = response.data.email;
      } catch (e) {}
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().required('Обязательно для заполнения'),
      password: Yup.string().required('Обязательно для заполнения'),
    }),
    validateOnMount: true,
  });

  const style = useStyles();

  return (
    <>
      <div className={classes.container}>
        <header className={classes.container__header}>
          <Logo />
        </header>
        <div className={classes.container__box}>
          <div className={classes.container__box__title}>
            <span>Авторизация</span>
          </div>
          <form onSubmit={handleSubmit}>
            <div>
              <div className={classes.title}>
                <p>E-mail, @ обязательно</p>
                <Point className={classes.title__point} />
              </div>
              <FormControl
                placeholder="Email"
                type="text"
                name="email"
                value={values.email}
                onChange={(e) => setFieldValue('email', e.target.value)}
                error={Boolean(errors?.email && touched?.email)}
                errorMessage={errors?.email}
                onBlur={handleBlur}
              />
            </div>
            <div>
              <div className={classes.title}>
                <p>Пароль</p>
                <Point className={classes.title__point} />
              </div>
              <FormControl
                placeholder="Пароль"
                type="password"
                name="password"
                value={values.password}
                onChange={(e) => setFieldValue('password', e.target.value)}
                error={Boolean(errors?.password && touched?.password)}
                errorMessage={errors?.password}
                onBlur={handleBlur}
              />
            </div>
            <div className={classes.container__box__entry}>
              <Button className={style.root} type="submit" disabled={!isValid}>
                Войти
              </Button>
              <span
                className={classes.container__box__entry__restore}
                onClick={(e) => setOpen(true)}
              >
                Восстановить пароль
              </span>
            </div>
          </form>
          <RestorePassword open={open} setOpen={setOpen} />
        </div>
      </div>
      <TwoFactorAuth
        handleClose={handleCloseAuth}
        open={openAuth}
        email={values.email}
        password={values.password}
      />
    </>
  );
};
